import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import shortid from 'shortid'
import moment from '../../lib/moment.js'
import get from 'lodash/get'
import { holiday_table_header, FONTS, COLORS } from '../../constants'
import arrow_down from '../../static/images/arrow-down.svg'
import arrow_up from '../../static/images/arrow-up.svg'


export default class PublicHolidayTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id: '',
      sort_order: null,
      sort_column: 0,
    }
    this.handleClickSort = this.handleClickSort.bind(this)
  }
  handleClickSort(type) {
    if (type === this.state.sort_column) {
      this.setState({
        sort_order: !this.state.sort_order,
      })
    } else {
      this.setState({
        sort_order: !this.state.sort_order,
        sort_column: type,
      })
    }
    if (type === 0) this.props.sortBy('date', !this.state.sort_order)
    else if (type === 1) this.props.sortBy('date', !this.state.sort_order)
    else if (type === 2) this.props.sortBy('description', !this.state.sort_order)
  }
  render() {
    const { sort_order, sort_column } = this.state
    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <NewTable bordered hover>
          <Header>
            <tr>
              {
                holiday_table_header.map((h) =>
                  (<HeadTable key={ shortid() } onClick={ () => this.handleClickSort(h.value) } >
                    { h.label }
                    { h.value === sort_column && (
                      sort_order && h.value === sort_column ?
                        <Icon src={ arrow_up } alt="logo" />
                        :
                        <Icon src={ arrow_down } alt="logo" />
                    )
                    }</HeadTable>)
                )}
            </tr>
          </Header>
          <BodyTable>
            { get(this.props, 'holidays', []).map((d, key) =>
              // d.is_active &&
              (<tr
                key={ shortid() }
                style={ { hover: '#E5E5E5', background: (key === get(this.props, 'rowID') && get(this.props, 'isSpan')) ? '#E5E5E5' : '' } }
                onClick={ () => this.props.handleClickRow(true, d._id, key) }
              >
                <td>{ new Date(d.date).getFullYear() }</td>
                <td>{ moment(d.date).format('DD/MM/YYYY') }</td>
                <td>{ d.description }</td>
              </tr>)
            )}
          </BodyTable>
        </NewTable>
      </Wrapper>
    )
  }
}

PublicHolidayTable.propTypes = {
  handleClickRow: PropTypes.func.isRequired,
  sortBy: PropTypes.func.isRequired,
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const NewTable = styled(Table)`
  background: white;
  thead{
    display:table;
    width:100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  } tbody tr {
    display:table;
    width:100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  }
`
const BodyTable = styled.tbody`
  width: 100% ;
  display: block ;
  max-height: calc(100vh - 200px);
  overflow-y:scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`
const HeadTable = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Icon = styled.img`
  height: 10px;
  margin-left: 5%;
  cursor: pointer;
`
const Header = styled.thead`
  background: ${COLORS.TABLE_HEADER_COLOR};
`



// WEBPACK FOOTER //
// ./src/components/table-public-holiday/index.js